import {  SET_SERVICE_PAGINATION } from "../ActionName/ActionName"

export const setServicePagination= (data) => {
    return {
        type:SET_SERVICE_PAGINATION ,
        value: data
    }
}



